/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_INVITE_USER, GetOpenReg } from "../graphql";
import { VApplication } from "../../../application";

const is = require("is_js");

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetInviteUserMethods extends IPluginMethodMap {
  getInviteUserProps(args: any): Promise<any>;
}

export class GetInviteUserService implements IAgentPlugin {
  readonly methods: IGetInviteUserMethods;

  constructor() {
    this.methods = {
      getInviteUserProps: this.getInviteUserProps.bind(this),
    };
  }

  async getInviteUserProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    // distakogni@gufum.com
    try {
      if (client) {
        // const id = await client.query({
        //   query: GetOpenReg,
        //   variables: {},
        //   fetchPolicy: "network-only",
        // });
        // if (id?.data) {
        //   const filter = {
        //     openRegID: id?.data?.getOpenReg?.openRegID,
        //   };
        //   console.log(id?.data)
        //   const res = await client.query({
        //     query: GET_INVITE_USER,
        //     variables: {
        //       filter: filter,
        //     },
        //     fetchPolicy: "network-only",
        //   });

        //   if (res?.data) {
        //     console.log("response from manageOpen Register===", res?.data);
        //     return {
        //       response: res?.data,
        //       formatted: this.formatCount(res?.data),
        //     };
        //   }
        // }
        return true;
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
  private formatCount(data?: any) {
    let arr = data?.getOpenInvite;

    let users: any = [];
    let dummy: any = [];
    console.log("open reg arr====", arr);
    for (let i = 0; i < arr.length; i++) {
      console.log(
        "array inside getOpenInvite",
        arr[i]?.sectionOptType[0]?.name,
      );
      if (arr[i]?.maxInvites > arr[i]?.referalUsed) {
        let str = arr[i]?.sectionOptType[0]?.name;

        if (dummy.includes(str) === false && str) {
          users.push({
            id: arr[i]?.sectionOptType[0]?.name,
            label: arr[i]?.sectionOptType[0]?.name,
          });
        }
        dummy.push(arr[i]?.sectionOptType[0]?.name);
      }
    }
    console.log("234723984723423", users, dummy);
    return users;
  }
}
